export default __webpack_public_path__ + "d162026b86b2c740bcfa6ee1714ee1d4.png";